// extracted by mini-css-extract-plugin
export var fadeInOut = "_3x-3";
export var icon = "_3x-4";
export var savedIndicator = "_3x-2";
export var savingIndicator = "_3x-0";
export var spin = "_3x-1";